import { render, staticRenderFns } from "./rules-setting.vue?vue&type=template&id=27731e2c&scoped=true&"
import script from "./rules-setting.vue?vue&type=script&lang=js&"
export * from "./rules-setting.vue?vue&type=script&lang=js&"
import style0 from "./rules-setting.vue?vue&type=style&index=0&id=27731e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27731e2c",
  null
  
)

export default component.exports